module.exports = __webpack_public_path__ + "assets/img/4437-ua.svg";